import { useState } from 'react';
import { Field } from 'formik';
import { Stack, Text, VStack } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

const AzureNameField = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!(errors?.name && touched?.name)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Stack>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Service Name <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a name for this ACS service.
                    </Text>
                </Stack>
                <Stack flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            name="name"
                            id="name"
                            placeholder="Enter service name"
                            validate={value => !value && 'Service name is required'}
                        />
                    </VStack>
                </Stack>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a descriptive name for this ACS service"
                        ariaLabel="name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AzureNameField;